import script from "./nonstockableReport.vue?vue&type=script&setup=true&lang=js"
export * from "./nonstockableReport.vue?vue&type=script&setup=true&lang=js"

import "./nonstockableReport.vue?vue&type=style&index=0&id=07166cbf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07166cbf"]])

export default __exports__